export default "Your account has not been activated yet.\nOnce it is done, you will be able to agree the terms & conditions regarding your license.\n"